import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { VerticalSupportOptionForm, VerticalSupportOptionFormType } from './VerticalSupportOptionForm'
import { createVerticalSupportOption } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Vertical Support Options',
    path: '/system/vertical-support-options'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddVerticalSupportOption = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createVerticalSupportOption({
        description: form.description,
        baseCost: form.baseCost,
        footCost: form.footCost,
        category: form.category || null
      })
      createToast('success', 'Vertical support option created')
      navigate('/system/vertical-support-options')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Vertical Support Option</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Option Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <VerticalSupportOptionForm
              type={VerticalSupportOptionFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
